module.exports = __webpack_public_path__ + "232abd2cb65f3ae407e7ce704aa26a3d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/micronaut.png
// module id = 269
// module chunks = 1